import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CsvRow } from '../models/CsvRow';
import { DhhpApiService } from 'src/app/core/services/dhhp-api.service';
import { HttpClient } from '@angular/common/http';
import { GenerateResponseRecord } from '../models/GenerateResponseRecord';
import { ActivationRecord } from '../models/ActivationRecord';
import { ActivatedRoute, Router } from '@angular/router';
import { ActivationCodeService } from '../../activation-code.service';
import { DhhpAlertComponent } from 'src/app/shared/dhhpalert/dhhpalert.component';
import { environment } from 'src/environments/environment';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-bulk-csv-form',
  templateUrl: './bulk-csv-form.component.html',
  styleUrls: ['./bulk-csv-form.component.scss']
})
export class BulkCsvFormComponent implements OnInit {

  bulkForm!: FormGroup;
  parsedRows: CsvRow[] = [];
  displayedColumns = ['value', 'status', 'error'];
  isValidated = false;
  uId: string = '';
  constructor(private fb: FormBuilder,
    private http: HttpClient,
    private apiService: DhhpApiService,
    private dhhpAlert: DhhpAlertComponent,
    private router: Router,
    private route: ActivatedRoute,
    private activationCodeService: ActivationCodeService,
    private afAuth: AngularFireAuth) { }

  ngOnInit(): void {

    this.afAuth.authState.subscribe(user => {
      if (user)
        this.uId = user.uid
      else
        this.uId = ''
    });

    this.bulkForm = this.fb.group({
      date: [null, Validators.required],
      batchNumber: ['', [Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      lotNumber: ['', [Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      csvData: ['', Validators.required]
    });

    this.bulkForm.valueChanges.subscribe(() => {
      if (this.isValidated) {
        this.isValidated = false;
        this.parsedRows = [];
      }
    })
  }

  validateCsv(): void {
    this.parsedRows = [];
    this.isValidated = false;

    if (this.bulkForm.invalid) return;

    const csvData: string = this.bulkForm.get('csvData')?.value;
    // console.log(csvData);
    const rows = csvData.split(',').map(r => r.trim()).filter(r => r.length > 0);

    const occuranceMap = new Map<string, number>();

    rows.forEach(value => {
      const key = value.toUpperCase();
      occuranceMap.set(key, (occuranceMap.get(key) || 0) + 1);
    });

    rows.forEach(row => {
      const key = row.toUpperCase();
      let result = this.validateItem(row);

      if (result.isValid && (occuranceMap.get(key) || 0) > 1) {
        result = { isValid: false, error: 'Duplicate value in CSV' }
      }

      this.parsedRows.push({
        raw: row,
        value: row,
        isValid: result.isValid,
        error: result.error
      });
    });

    this.isValidated = true
  }

  validateItem(value: string): { isValid: boolean; error?: string } {
    const regex = /^WU\d{2}\d{2}\d{6}$/;

    if (!regex.test(value)) {
      return { isValid: false, error: 'Format must be WUYYWWXXXXXX' };
    }

    const year = Number(value.substr(2, 2));
    const week = Number(value.substr(4, 2));

    if (week < 1 || week > 53) {
      return { isValid: false, error: 'Invalid calendar week' };
    }

    return { isValid: true };
  }

  isGenerateDisabled() {
    return !this.isValidated || this.parsedRows.some(r => !r.isValid);
  }

  generate(): void {
    if (!this.isValidated || this.parsedRows.some(r => !r.isValid)) {
      return;
    }

    const payload = {
      requestedBy: this.getLoggedInUserId(), //firebase uId for audit purpose
      batchId: this.bulkForm.value.batchNumber,
      lotId: this.bulkForm.value.lotNumber,
      manufacturedOn: this.bulkForm.value.date.toISOString() ?? new Date().toISOString(),
      countryCode: "DE",
      serialNumbers: this.parsedRows.map(r => r.value)
    };

    this.http.post<GenerateResponseRecord[]>(environment.functionAppBaseUri + 'api/GenerateCodes', payload)
      .subscribe({
        next: (records) => {
          var recordList = records as GenerateResponseRecord[];
          const data: ActivationRecord[] = recordList.map(item => ({
            serialNumber: item.SerialNumber,
            activationCode: item.Code
          }));
          this.activationCodeService.setData(data);
          this.router.navigate(['new-list/'], { relativeTo: this.route });
        },
        error: (err) => {
          let message = 'An error occured, please contact the admnistrator.';
          this.dhhpAlert.dhhpAlertError(message, '')
        }
      });
  }

  onCsvInputChange(value: string): void {
    if (!value) {
      return;
    }

    const cleaned: string = value.replace(/\r?\n/g, ',').replace(/\s+/g, '').replace(/,+/g, ',').replace(/^,|,$/g, '');
    this.bulkForm.get('csvData')?.setValue(cleaned, { emitEvent: false });
  }

  getLoggedInUserId(): string {
    return this.uId
  }
}
